import { Authority } from 'platform/app/authority.constant';

export const FEEDS = {
    name: 'Feeds',
    path: '/admin-panel/feeds',
    requiresAuthority: Authority.ROLE_ADMIN_PANEL_VIEW_EDIT,
};
